import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { useState } from "react";

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 text-white py-2.5 px-4 text-center overflow-hidden">
      {/* Animated background effect */}
      <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.1)_50%,transparent_75%)] bg-[length:250%_250%] animate-[shimmer_3s_linear_infinite]" />
      
      <div className="relative flex items-center justify-center gap-2 text-sm font-medium">
        <Sparkles className="h-4 w-4 animate-pulse" />
        <span className="hidden sm:inline">
          <span className="font-bold">Nano Banana Pro</span> & <span className="font-bold">Seedream V4.5</span> sont arrivés !
        </span>
        <span className="sm:hidden">
          <span className="font-bold">Nouveau :</span> Colorométrie
        </span>
        <Link 
          to="/colorgrading" 
          className="inline-flex items-center gap-1 ml-2 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-full transition-colors font-semibold"
        >
          Découvrir Colorométrie
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>

      {/* Close button */}
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Fermer l'annonce"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;

